import React from 'react';
import { Phone, Mail } from 'lucide-react';

// Tap-to-call / tap-to-email pills for admin cards on phones
const QuickContact = ({ phone, email, testId, className = '' }) => {
  if (!phone && !email) return null;
  const cls = 'inline-flex items-center justify-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium active:scale-95 transition-transform';
  return (
    <div className={`flex flex-wrap gap-2 ${className}`} data-testid={testId ? `${testId}-quick-contact` : undefined}>
      {phone && <a href={`tel:${String(phone).replace(/[^+\d]/g, '')}`} onClick={(e) => e.stopPropagation()} className={`${cls} border-green-200 bg-green-50 text-green-700`} data-testid={testId ? `${testId}-call` : undefined}><Phone size={13} /> Appeler</a>}
      {email && <a href={`mailto:${email}`} onClick={(e) => e.stopPropagation()} className={`${cls} border-blue-200 bg-blue-50 text-blue-700`} data-testid={testId ? `${testId}-email` : undefined}><Mail size={13} /> E-mail</a>}
    </div>
  );
};

export default QuickContact;
